export default __webpack_public_path__ + "static/media/authentic.26442b40.png";